import { render, staticRenderFns } from "./objects.vue?vue&type=template&id=dbbd29c4&"
import script from "./objects.vue?vue&type=script&lang=js&"
export * from "./objects.vue?vue&type=script&lang=js&"
import style0 from "./objects.vue?vue&type=style&index=0&id=dbbd29c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports